<template>
  <div class="layout">
    <Sidebar @toggle-sidebar="toggleSidebar" />
    <div class="main-content" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <div class="page-header">
        <div class="header-left">
          <button class="back-button" @click="goBack">
            <i class="fas fa-arrow-left"></i> Back to Sections
          </button>
          <h1>Section Details</h1>
        </div>
      </div>
      
      <HomepageSectionDetail 
        :sectionId="sectionId" 
        @section-updated="handleSectionUpdated"
        @section-deleted="handleSectionDeleted"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import HomepageSectionDetail from '@/components/HomepageSectionDetail.vue';

export default {
  name: 'HomepageSectionDetailView',
  components: {
    Sidebar,
    HomepageSectionDetail
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isSidebarCollapsed = ref(false);
    
    const sectionId = computed(() => route.params.id);

    const toggleSidebar = () => {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    };

    const goBack = () => {
      router.push('/homepage/sections');
    };

    const handleSectionUpdated = (section) => {
      console.log('Section updated:', section);
      // You can add additional logic here if needed
    };

    const handleSectionDeleted = (id) => {
      console.log('Section deleted:', id);
      // Additional logic can be added here if needed
    };

    return {
      sectionId,
      isSidebarCollapsed,
      toggleSidebar,
      goBack,
      handleSectionUpdated,
      handleSectionDeleted
    };
  }
};
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;
  padding: 2rem;
}

.main-content.sidebar-collapsed {
  margin-left: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-header h1 {
  font-size: 1.8rem;
  color: #1F2937;
  margin: 0;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background: #F3F4F6;
  color: #4B5563;
}

.back-button:hover {
  background: #E5E7EB;
}

@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }
  
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .header-left {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style> 